import { maskString } from './mask-string'

// fullname.util.ts
type NameData = {
  first_name: string
  middle_name?: string
  last_name: string
}

export const getFullName = (
  nameData?: NameData | null,
  excludeMiddleName: boolean = false,
  is_mask: boolean = false,
  defaultValue: string = '',
): string => {
  if (nameData) {
    const { first_name, middle_name, last_name } = nameData
    const middleInitial = excludeMiddleName
      ? ''
      : middle_name
        ? `${middle_name.charAt(0)}.`
        : ''
    const parts = [
      is_mask ? maskString(first_name) : first_name,
      middleInitial,
      is_mask ? maskString(last_name) : last_name,
    ].filter((p): p is string => p != null && p !== '')
    return parts.join(' ')
  } else return defaultValue
}
